import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from '../../common/pagination'
import { PAGE_SIZE_OPTIONS } from '../../common/pagination/constants'
import { SCREEN_TYPE } from '../constants'
import {
  changePage,
  changePageSize,
  selectPage,
  selectPageSize,
  selectRawData,
} from '../store/slice'

const WrapPagination = () => {
  const dispatch = useDispatch()

  const page = useSelector(selectPage(SCREEN_TYPE.VIEW_ALL))
  const pageSize = useSelector(selectPageSize)
  const rawData = useSelector(selectRawData(SCREEN_TYPE.VIEW_ALL))

  const handleSetPage = (value) => {
    dispatch(changePage({ screenType: SCREEN_TYPE.VIEW_ALL, newPage: value }))
  }

  const setPageSize = (value) => {
    dispatch(changePageSize(value))
  }

  return (
    <div style={{ paddingBottom: '24px' }}>
      <Pagination
        page={page}
        pageSize={pageSize}
        total={rawData.totalRecords}
        setPage={handleSetPage}
        setPageSize={setPageSize}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
      />
    </div>
  )
}

export default WrapPagination
